import React from 'react';
import {FieldSalesLeaderUserType} from 'Users/models/User/Agent/FieldSalesLeaderUserType';
import {FormControlLabel, Switch} from '@material-ui/core';
import './FieldSalesLeaderEntry.sass';
import {useDispatch} from 'react-redux';
import {
  changeFieldSalesLeaderRecruiterCode,
  changeFieldSalesLeaderAHL,
  changeFieldSalesLeaderNewYork,
} from 'Users/ducks/fieldSalesLeaderUserType';
import RecruiterCodeInput from 'Users/components/UserAdministration/UserEntry/Agent/RecruiterCodeInput';

type FieldSalesLeaderEntryProps = {
  fieldSalesLeaderUserType: FieldSalesLeaderUserType;
  isEdit: boolean;
  hasUpdateAccess: boolean;
};

const FieldSalesLeaderEntry = (props: FieldSalesLeaderEntryProps) => {
  const dispatch = useDispatch();
  const {hasAhlAccess, hasNewYorkAccess, recruiterCode} = props.fieldSalesLeaderUserType;
  const selectedRecruiterCode = props.isEdit || (recruiterCode.hasAhlAccess && recruiterCode.hasNewYorkAccess);

  return (
    <div className="field-sales-leader-entry">
      <RecruiterCodeInput
        label="Recruiter Code"
        className="field-sales-leader-entry__field"
        onChange={recruiterCode =>
          dispatch(
            changeFieldSalesLeaderRecruiterCode(recruiterCode.value!, recruiterCode.isAhl!, recruiterCode.isNewYork!)
          )
        }
        recruiterCode={recruiterCode}
        disabled={!props.hasUpdateAccess && props.isEdit}
      />
      {selectedRecruiterCode && (
        <>
          <p className="field-sales-leader-entry__additional-access-description">
            The selected recruiter code is used in by both AHL and New York agent numbers. Please ensure whether you
            would like access to be given to both contexts or only one.
          </p>
          <FormControlLabel
            label="Grant American Heritage Life Access?"
            className="field-sales-leader-entry__field"
            control={
              <Switch
                color="primary"
                checked={hasAhlAccess}
                onChange={e => dispatch(changeFieldSalesLeaderAHL(e.currentTarget.checked))}
                disabled={!props.hasUpdateAccess && props.isEdit}
              />
            }
          />
          <FormControlLabel
            label="Grant New York Access?"
            className="field-sales-leader-entry__field"
            control={
              <Switch
                color="primary"
                checked={hasNewYorkAccess}
                onChange={e => dispatch(changeFieldSalesLeaderNewYork(e.currentTarget.checked))}
                disabled={!props.hasUpdateAccess && props.isEdit}
              />
            }
          />
        </>
      )}
    </div>
  );
};

export default FieldSalesLeaderEntry;
